import { useTranslations } from "next-intl";
import React, { FC } from "react";

import Icon from "../ui/Icon/Icon";

interface Props {}
const Pagination: FC<Props> = () => {
  const t = useTranslations();
  return <></>;
};

export default Pagination;
